var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "syf-component-library/ui/spacing/Stack";
import { useTranslation } from "react-i18next";
import { ErrorImage, ErrorImageCard, ImageContentWrapper, Subtitle, Title, } from "./subcomponents";
import { useConfig } from "../../../hooks/useConfig";
import { IMAGE_ASSETS } from "../../../const/assets";
var ErrorPage = function () {
    var t = useTranslation().t;
    var assets = useConfig().hosts.assets;
    return (_jsxs(ImageContentWrapper, { children: [_jsx(ErrorImage, { src: "".concat(assets).concat(IMAGE_ASSETS.CAT_ERROR), alt: "error" }), _jsxs(ErrorImageCard, { children: [_jsx(Stack, { size: "large" }), _jsx(Title, __assign({ as: "h1", weight: "semiBold" }, { children: t("error.technicalDifficultiesV2") })), _jsx(Stack, { size: "large" }), _jsx(Subtitle, { children: t("error.tryAgainLaterV2") })] })] }));
};
export default ErrorPage;
